import React, { useCallback, useEffect, useState } from "react";

// kendo
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Button } from "@progress/kendo-react-buttons";
import { Grid, GridColumn, GridNoRecords, getSelectedState } from "@progress/kendo-react-grid";
import { getter } from "@progress/kendo-react-common";
import { Upload } from "@progress/kendo-react-upload";

// css
import "./deviceCmd.css";
import styles from './deviceCmd.module.css';
import {CheckBox, Search, Check } from "@material-ui/icons";

// Service
import { IntlProvider, LocalizationProvider } from "@progress/kendo-react-intl";
import { getDeviceDataList, setDeviceData, setDangerEvent } from "../../../service/mngt/device/deviceCtrl";
import { getUser, isAdmin, isManager, isDeveloper } from '../../../service/authService';
import { getRgns, getDongs } from './../../../service/areaService';
import { getUsers } from '../../../service/monitor/allStatusService';

// Filter
import GridColumnInputFilter from "../../com/gridFilter/gridColumnInputFilter";
import CustomFilter from "../../com/gridFilter/custom_filter";

// Translate
import DeviceInfo from "./deviceInfo";
import DeviceCmdInfo from "./deviceCmdInfo";
import ElderLogSearch from './../../log/elder/elderLogSearch';

const DATA_ITEM_KEY = "cid";
const SELECTED_FILED = "selected";
const idGetter = getter(DATA_ITEM_KEY);

const DeviceCmd = ({conn, rgnList, dongList }) => {
  
  const userInfo = getUser();

  const cmdList = [
    "제어 명령 선택", 
    "연결 상태 확인",
    "응급 신호 호출", 
    "센서테스트",
    "RESET",
    "설정변경",
    "펌웨어 업데이트",        
  ];  

  const signType = ["응급신호(A타입)", "응급신호(B타입)"]

  // 장비 관리 페이지 데이터 리스트 
  const [deviceList, setDeviceList] = useState([]);

  // 장비 이력 정보 
  const [deviceInfo, setDeviceInfo] = useState({
    visible: false, 
    dataItem: [],
  });

  // 장비 선택 정보 
  const [selectedDevList, setSelectedDevList] = useState([]);

  // 장비 제어 명령 정보 - 명령 종류에 따라 팝업 필요
  const [deviceCmdInfo, setDeviceCmdInfo] = useState({
    visible: false,
    cmdType: "",
    emergencyTypeTerm: "", 
  });
  
  // 장비 수정 정보 
  const [altDevInfo, setAltDevInfo] = useState({
    cycle: null, // 수집 주기
    lidar: null, // 센서 감도
  });
  
  const [selectedState, setSelectedState] = useState({});   

  const [filesState, setFilesState] = useState({
    files: [],
    fileInfo: [],
    fileId: "",
  })

  const [dataState, setDataState] = useState({
    skip: 0,
    take: 20,
    // 드롭다운 시군구 표출 값
    rgnCode: userInfo.rgnCode,
    rgnTermSimple: null,
    rgns : { rgnTermSimple: "시/군/구", rgnCode: "" },
    // 드롭다운 읍면동 표출 값
    dongCode: userInfo.dongCode,
    dongTermSimple: null,
    dongs : { dongTermSimple: "읍/면/동", dongCode: "" },
    // 드롭다운 유저 표출 값
    userId: '',
    userTerm: '',
    users : { userTerm: "대상자 선택", userId: "" },

    // 장비 제어 STATE
    deviceList: [],
    cmdType: null,
    cmdStatus: null,
    emergencyType: null,
    altDeviceCycle: null,
    altLidarDistance: null,
    fileName: null,
  });

  const [dataSource, setDataSource] = useState({
    results: [],
    total: 0,
    rgnList: [], 
    dongList: [],
    userList: [],
    locationLogList: [],
  });

  const defualtValRgn = { rgnTermSimple: "시/군/구", rgnCode: "" };
  const defualtValDong = { dongTermSimple: "읍/면/동", dongCode: "" };
  const defaultValUser = { userTerm: "대상자 선택", userId: "" };

  // 초기 데이터 가져오기
  const getDataList = () => {
    setLoading(true);
    // 시군구
    getRgns(conn)
    .then(response => {
      setDataState(dataState => {
        const item = { ...dataState };
        item.rgns = response.find(item => item.rgnCode === userInfo.rgnCode);
        return item;
      })
      setDataSource(dataSource => {
        const item = { ...dataSource };
        item.rgnList = response
        return item;
      })
      setLoading(false);
    })
    .catch(error => {
      console.log("getRgns error = ", error);
    });
    // 읍면동
    getDongs(conn, userInfo.rgnCode)
    .then(response => {
      setDataState(dataState => {
        const item = { ...dataState };
        item.dongs = response.find(item => item.dongCode === userInfo.dongCode);
        return item;
      })
      setDataSource(dataSource => {
        const item = { ...dataSource };
        item.dongList = response;
        return item;
      })
      setLoading(false);
    })
    .catch(error => {
      console.log("getDongs error = ", error);
    });
    // 대상자
    getUsers(conn, dataState)
    .then(response => {
      setDataSource(dataSource => {
        const item = { ...dataSource };
        // item.userList = response;
        item.userList = response.filter(item => item.meainStatCode !== "20005" && item.bizType === "5003");
        return item;
      })
    })
    .catch(error => {
      console.log("getUserList error = ", error);
    })
  }

  // 시군구, 읍면동, 대상자 드롭다운 체인지 이벤트
  const changeDropEvent = e => {
    if (e.target.name === "rgn") {
      setDataState(dataState => {
        const item = { ...dataState };
        // 드롭다운 검색조건 변경
        item.rgnCode = e.target.value.rgnCode;
        item.rgns = e.target.value;
        // 하위 데이터 초기화
        item.dongs = { dongTermSimple: "읍/면/동", dongCode: "" };
        item.dongCode = "";
        item.users = { userTerm: "대상자 선택", userId: "" };;
        item.userId = "";
        item.userTerm = "";
        // 대상자 데이터 조회
        getUsers(conn, item)
        .then(response => {
          setDataSource(dataSource => {
            const item = { ...dataSource };
            // item.userList = response;
            item.userList = response.filter(item => item.meainStatCode !== "20005" && item.bizType === "5003");
            return item;
          })
        })
        .catch(error => {
          console.log("getUserList error = ", error);
        })
        return item;
      })
      // 읍면동 데이터 조회
      getDongs(conn, e.value.rgnCode)
      .then(result => {
        setDataSource(dataSource => {
          const item = { ...dataSource };
          item.dongList = result;
          return item;
        })
      })
      .catch(error => {
        console.log("getDongs error = ", error);
      });

    } else if (e.target.name === "dong") {
      setDataState(dataState => {
        const item = { ...dataState };
        // 드롭다운 검색조건 변경
        item.dongCode = e.target.value.dongCode;
        item.dongs = e.target.value;
        // 하위 데이터 초기화
        item.users = { userTerm: "대상자 선택", userId: "" };;
        item.userId = "";
        item.userTerm = "";
        // 대상자 데이터 조회
        getUsers(conn, item)
        .then(response => {
          setDataSource(dataSource => {
            const item = { ...dataSource };
            // item.userList = response;
            item.userList = response.filter(item => item.meainStatCode !== "20005" && item.bizType === "5003");
            return item;
          })
        })
        .catch(error => {
          console.log("getUserList error = ", error);
        })
        return item;
      })
    } else if (e.target.name === 'user') {
      // 드롭다운 검색조건 변경
      if(e.target.value.userTerm === "대상자 선택") {
        setDataState(dataState => {
          const item = { ...dataState };
          item.userId = e.target.value.userId;
          item.userTerm = "";
          item.users = e.target.value;
          return item;
        })
      } else {
        setDataState(dataState => {
          const item = { ...dataState };
          item.userId = e.target.value.userId;
          item.userTerm = e.target.value.userTerm;
          item.users = e.target.value;
          return item;
        })
      }
    }
  }

  // 조회 버튼
  const searchBtnClickEvt = e => {
    
    // 페이징
    dataState.skip = 0;
    dataState.take = 20;
    getDeviceList();

  };

  // 리셋 버튼
  const renewBtnClickEvt = e => {

    // 데이터 초기화
    dataState.skip = 0;
    dataState.take = 20;
    
    dataState.userId = "";
    dataState.userTerm = "";
    
    dataState.users = { userTerm: "대상자 선택", userId: "" };
    dataState.meainStatCode = '';
    dataState.bizType = '';
    dataState.dangerElderYn = '';

    dataState.rgns = { rgnTermSimple: "시/군/구", rgnCode: "" };
    dataState.rgnCode = "";
    dataState.dongs = { dongTermSimple: "읍/면/동", dongCode: "" };
    dataState.dongCode = "";

    getDeviceList();
  };

  // 장비 개별 선택
  const onSelectionChange = useCallback((event) => {
    if(event.syntheticEvent) {
      const checked = event.syntheticEvent.target.checked;      

      /**
       * 체크를 했을 때, 선택된 장비 리스트 초기화
       * 체크를 풀 경우, 해당 장비 삭제 
       */
      if(checked) {
        setSelectedDevList(device => {
          const item = [...device];
          item.push(event.dataItem);
          return item;
        });
      } else {
        setSelectedDevList(selectedDevList.filter(device => device.cid !== event.dataItem.cid));
      } 
    }    
    const newSelectedState = getSelectedState({
      event,
      selectedState: selectedState,
      dataItemKey: DATA_ITEM_KEY,
    });
    setSelectedState(newSelectedState);          

  }, [selectedState]);

  // 장비 전체 선택
  const onHeaderSelectionChange = useCallback((event) => {   
    const checkboxElement = event.syntheticEvent.target;
    const checked = checkboxElement.checked;
    const newSelectedState = {};
    
    event.target.props.data.forEach((item) => {
      newSelectedState[idGetter(item)] = checked;
    });
    setSelectedState(newSelectedState);    

    /**
     * 체크를 했을 때, 전체 장비 리스트 초기화
     * 체크를 풀 경우, 전체 장비 삭제 
     */
    if(checked) {
      setSelectedDevList(device => {
        const item = [...device];
        item.push(event.dataItems);
        return item;
      });
    } else {
      setSelectedDevList([]);
    } 

  }, []);

  // 제어 명령 선택 드롭다운
  const changeDropDownEvt = (e) => {   

    setSelectedDevList([]);
    setSelectedState({}); 

    // 세부 데이터 초기화
    setDataState((dataState) => {
      const item = { ...dataState };
      item.emergencyTypeTerm = null;
      return item;
    })

    const cmdType = e.target.value;
    if(cmdType) {
      setDeviceCmdInfo(deviceCmdInfo => {
        const item = {...deviceCmdInfo};
        item.cmdType = cmdType;
        if(cmdType === "설정변경" || cmdType === "펌웨어 업데이트" || cmdType === "응급 신호 호출") {
          item.visible = true;
        } else {
          item.visible = false;
        }
        return item;
      });
    }
  }

  // 응급신호호출 : 응급신호 타입 드롭다운
  const changeEmergencyType = (e) => {
    setDeviceCmdInfo((deviceCmdInfo) => {
      const item = { ...deviceCmdInfo };
      item.emergencyTypeTerm = e.target.value;
      return item;
    })
  }

  // 설정변경 : 주기, 센서감도 입력
  const inputEvent = e => {
    const enteredValue = e.target.value;
    const numericInput = enteredValue.replace(/[^0-9]/g, '') // Remove all non-numeric characters
    const inputId = e.target.id;
    if(inputId === "altDeviceCycle") {
      setAltDevInfo(altDevInfo => {
        const item = { ...altDevInfo };
        item.cycle = parseInt(numericInput);
        return item;
      })
    } else if(inputId === "altLidarDistance") {
      setAltDevInfo(altDevInfo => {
        const item = { ...altDevInfo };
        item.lidar = parseInt(numericInput);
        return item;
      })
    }
  }

   const onAdd = e => {

    setFilesState(state => {
      const item = { ...state };
      item.files = e.newState;
      item.fileInfo = encodeURI(JSON.stringify(e.affectedFiles));
      return item;
    });

    console.log("onAdd", e.affectedFiles);

  };

  const onRemove = useCallback(
  
  );

  const onProgress = e => {
    const { affectedFiles, serverResponse } = e;
    console.log("onProgress.affectedFiles", affectedFiles);
    console.log("onProgress.serverResponse", serverResponse);

    setFilesState(state => {
      const item = { ...state };
      item.files = e.newState;
      return item;
    });
  };

  const onStatusChange = e => {
    console.log("onStatusChange ", e);
    //수정 버튼 클릭 시
    if (e.response !== undefined) {
      const { fileId } = e.response.response.data[0];
      const fileName = e.affectedFiles[0].name;
      setDataState(dataState => {
        const item = { ...dataState };
        item.fileName = fileName;
        return item;
      });
      // tbh_device_cmd 테이블 FIRMWARE_NAME 디바이스 펌웨어 파일명 저장
    }

    setFilesState(state => {
      const item = { ...state };
      item.files = e.newState;
      return item;
    });
  }

  // 실행 버튼
  const changeStatus = (e) => {
    if(deviceCmdInfo.cmdType === "" || deviceCmdInfo.cmdType === "제어 명령 선택") {
      alert("제어 명령을 선택해주세요");
      return;
    } else {
      if(selectedDevList.length === 0) {
        alert("장비를 선택해주세요");
        return;
      } else {
        if(deviceCmdInfo.cmdType === "연결 상태 확인") {
          setDataState((dataState) => {
            const item = { ...dataState };
            item.deviceList = selectedDevList;
            item.cmdType = 1;
            item.cmdStatus = 1;
            item.emergencyType = null;
            item.altDeviceCycle = null;
            item.altLidarDistance = null;
            item.fileId = null;
            setDeviceData(conn, item);
            return item;
          })
        } else if(deviceCmdInfo.cmdType === "응급 신호 호출") {
          if(deviceCmdInfo.emergencyTypeTerm === "응급신호(A타입)") {
            setDataState((dataState) => {
              const item = { ...dataState };
              item.deviceList = selectedDevList;
              item.cmdType = 2;
              item.cmdStatus = 1;
              item.emergencyType = 1;
              item.altDeviceCycle = null;
              item.altLidarDistance = null;
              item.fileId = null;
              setDeviceData(conn, item);
              return item;
            })
          } else if(deviceCmdInfo.emergencyTypeTerm === "응급신호(B타입)") {
            setDataState((dataState) => {
              const item = { ...dataState };
              item.deviceList = selectedDevList;
              item.cmdType = 2;
              item.cmdStatus = 1;
              item.emergencyType = 2;
              item.altDeviceCycle = null;
              item.altLidarDistance = null;
              item.fileId = null;
              setDeviceData(conn, item);
              return item;
            })
          } else {
            alert("응급신호 타입을 선택해주세요");
            return;
          }
        } else if(deviceCmdInfo.cmdType === "센서테스트") {
          setDataState((dataState) => {
            const item = { ...dataState };
            item.deviceList = selectedDevList;
            item.cmdType = 3;
            item.cmdStatus = 1;
            item.emergencyType = null;
            item.altDeviceCycle = null;
            item.altLidarDistance = null;
            item.fileId = null;
            setDeviceData(conn, item);
            return item;
          })
        } else if(deviceCmdInfo.cmdType === "RESET") {
          setDataState((dataState) => {
            const item = { ...dataState };
            item.deviceList = selectedDevList;
            item.cmdType = 4;
            item.cmdStatus = 1;
            item.emergencyType = null;
            item.altDeviceCycle = null;
            item.altLidarDistance = null;
            item.fileId = null;
            setDeviceData(conn, item);
            return item;
          })
        } else if(deviceCmdInfo.cmdType === "설정변경") {
          if(altDevInfo.cycle && altDevInfo.lidar) {
            if(altDevInfo.lidar < 1 || altDevInfo.lidar > 3) {
              alert("센서감도는 1~3 까지 입력이 가능합니다")
              return;
            }
            setDataState((dataState) => {
              const item = { ...dataState };
              item.deviceList = selectedDevList;
              item.cmdType = 5;
              item.cmdStatus = 1;
              item.emergencyType = null;
              item.altDeviceCycle = altDevInfo.cycle;
              item.altLidarDistance = altDevInfo.lidar;
              item.fileId = null;
              setDeviceData(conn, item);
              return item;
            })
          } else {
            alert("주기와 센서감도 값을 확인해주세요");
            return;
          }
        } else if(deviceCmdInfo.cmdType === "펌웨어 업데이트") {
          setDataState((dataState) => {
            const item = { ...dataState };
            item.deviceList = selectedDevList;
            item.cmdType = 6;
            item.cmdStatus = 1;
            item.emergencyType = null;
            item.altDeviceCycle = null;
            item.altLidarDistance = null;
            setDeviceData(conn, item);
            return item;
          })
        }
        alert("제어 명령을 실행하였습니다.");
        getDeviceList();
      }
    }
  }
  
  const dongTermList = dongList.map(e => {
    e.dongTerm = e.dongTerm.split(' ')[e.dongTerm.split(' ').length-1];
    return e;
  });
  

  const [loading, setLoading] = useState(false);

  // 페이저 
  const [pager, setPager] = useState({
    total: 0,
    skip: 0,
    take: 20,
    cid: "",
    userTerm: "",
    rgnCode: "",
    dongCode: "",
  });

 

  /* -------------------------------------------------------------- service 및 데이터 조회  */

  // 장비 리스트 조회 
  const getDeviceList = () => {    
    setLoading(true);
    setSelectedDevList([]);
    setSelectedState({});
    getDeviceDataList(conn, dataState, getDeviceListResult, getRejection, setLoading);
  }

  // 조회 callback
  const getDeviceListResult = result => {   
    setDataSource(dataSource => {
      const item = { ...dataSource };
      item.results = result.results.map(dataItem => Object.assign({ selected: false }, dataItem));
      item.total = result.total;
      return item;
    });
    // pager.total = result.total;     
    // setDeviceList(result.results);
  }

  // 공용 rejection 
  const getRejection = reject => {
    console.log('getRejection = ', reject);
  }

  /* --------------------------------------------------------------------- gridEvent  */
  // 그리드 페이징 처리
  const handlePageChange = e => {
    const { take, skip } = e.page;

    dataState.skip = skip;
    dataState.take = take;
    
    getDeviceList();
  };
 
  // 그리드 필터링 처리
  const handleFilterChange = e => {          
    // 필터 값 설정
    const isFilter = e.filter.filters[0];        
    if (isFilter.field === "cid") {      
      pager.cid = isFilter.value;
    } else if (isFilter.field === "userTerm") {
      pager.userTerm = isFilter.value;
    } else if(isFilter.field === "rgnTerm") {      
      pager.rgnCode = isFilter.value.rgnCode;      
    } else if (isFilter.field === "dongTermSimple") {      
      pager.dongCode = isFilter.value.dongCode;
    } 

    pager.skip = 0;
    pager.take = 0;

    getDeviceList();
  };
  
  const rgnFilterDropDown = CustomFilter(
    rgnList,
    { rgnCode: "", rgnTerm: "시/군/구" },
    "rgnCode",
    "rgnTerm",
    true,
    userInfo.userTypeCode === 2002,
  );

  const dongFilterDropDown = CustomFilter(
    dongTermList,
    { dongCode: "", dongTerm: "읍/면/동" },
    "dongCode",
    "dongTerm",
    true,
    userInfo.userTypeCode === 2002,
  );

  /* --------------------------------------------------------------------- device info event  */
  const devInfoEvtBtn = dataItem => {

    setDeviceInfo(deviceInfo => {
      const item = {...deviceInfo};
      item.visible = true;
      item.dataItem = dataItem;
      return item;
    });
  }

  const dangerEvent = dataItem => {
    setDangerEvent(conn, dataItem)
  }
  /* --------------------------------------------------------------------- device setting change event  */

  
  useEffect(() => {
    getDataList();
    // getDeviceList()
    getDeviceList();    
  }, []);



  return(
    <>
      <div className={styles.deviceCmdSearch}>
        {/* <span className={styles.searchTitle}>시군구</span> */}
        <DropDownList
          id="rgn"
          name="rgn"
          data={dataSource.rgnList}
          disabled={!isDeveloper() ? true : false}
          className="allStatusSearchDropdown"
          value={dataState.rgns}
          textField="rgnTermSimple"
          dataItemKey="rgnCode"
          defaultItem={defualtValRgn}
          onChange={changeDropEvent}
        />
        {/* <span className={styles.searchTitle}>읍면동</span> */}
        <DropDownList
          id="dong"
          name="dong"
          data={dataSource.dongList}
          disabled={!isAdmin() ? true : !dataState.rgnCode ? true : false}
          className="allStatusSearchDropdown"
          value={dataState.dongs}
          textField="dongTermSimple"
          dataItemKey="dongCode"
          defaultItem={defualtValDong}
          onChange={changeDropEvent}
        />
        {/* <span className={styles.searchTitle}>대상자</span> */}
        <DropDownList
          id="user"
          name="user"
          data={dataSource.userList}
          className="allStatusSearchDropdown"
          value={dataState.users}
          textField="userTerm"
          dataItemKey="userId"
          defaultItem={defaultValUser}
          onChange={changeDropEvent}
        />
        <Button className={styles.searchButton} icon="search" onClick={searchBtnClickEvt}>조회</Button>
        <Button className={styles.searchButton} icon="refresh" onClick={renewBtnClickEvt}>리셋</Button>
      </div>
        <div className={styles.deviceCtrlDiv}>        
          <span className="deviceCtrlSpan">제어기능</span>
          <DropDownList
            className="deviceCtrlDropDownList"
            id="cmdDdl"
            name="cmdDdl"
            data={cmdList}
            defaultValue={cmdList[0]}
            onChange={changeDropDownEvt}
          />       
          {deviceCmdInfo.visible && deviceCmdInfo.cmdType === '설정변경' ? (
            <>
              <span className="deviceCtrlSpan">주기</span>
              <input 
                id="altDeviceCycle"
                className="deviceCtrlInput"
                type="number"
                pattern="[0-9]*"
                placeholder="데이터 수집주기 입력(초 단위)"
                // value={altDevInfo.cycle}
                onChange={inputEvent}
              />                      
              <span className="deviceCtrlSpan">센서감도</span>
              <input 
                id="altLidarDistance"
                className="deviceCtrlInput" 
                type="number"
                min={1}
                max={3}
                placeholder="센서 감도 입력 (1~3)" 
                // value={altDevInfo.lidar}
                onChange={inputEvent}
              />
            </>
          ) : null}
          {deviceCmdInfo.visible && deviceCmdInfo.cmdType === '펌웨어 업데이트' ? (
            <div className={styles.firmwareUpdate}>
              <div className={styles.firmwareUpdateSpan}>파일</div>
              <div className={styles.firmwareUpdateFile}>
              <LocalizationProvider language="ko-KR">
                <IntlProvider locale="ko">
                  <Upload
                    className="fileUpload"
                    // showFileList={false}
                    autoUpload={false}
                    batch={true}
                    multiple={false}
                    files={filesState.files}
                    defaultFiles={[]}
                    onAdd={onAdd}
                    onRemove={onRemove}
                    onProgress={onProgress}
                    onStatusChange={onStatusChange}
                    withCredentials={true}
                    removeVerb={"DELETE"}
                    restrictions={{
                      allowedExtensions: [".bin"],
                      maxFileSize: 10240000,
                    }}
                    saveMethod={"post"}
                    saveHeaders={{
                      "Content-Type": "multipart/form-data",
                      "X-AUTH-TOKEN": localStorage.getItem(`${process.env.REACT_APP_TOKEN}`),
                    }}
                    saveUrl={"/api/v2.2/device/upload?fileInfo=" + filesState.fileInfo}
                    removeUrl={"/device/file/delete"}
                  />
                </IntlProvider>
              </LocalizationProvider>
              </div>
            </div>
          ) : null}
          {deviceCmdInfo.visible && deviceCmdInfo.cmdType === '응급 신호 호출' ? (
            <>
              <span className="deviceCtrlSpan">타입</span>
              <DropDownList
                data={signType}
                defaultItem={"응급신호 타입"}
                onChange={changeEmergencyType}
              />
            </>
          ) : null}
          <Button className="deviceCtrlButton" onClick={changeStatus}>실행</Button> 
        </div>

        <div className={styles.deviceCmdGrid}>
          <LocalizationProvider language="ko-KR">
            <IntlProvider locale="ko">
              <Grid        
                className={styles.grid}
                style={{height: "100%"}}                    
                data={dataSource.results.map((item) => ({
                  ...item,
                  [SELECTED_FILED]: selectedState[idGetter(item)],
                }))}
                // data = {deviceList}
                skip={dataState.skip}
                take={dataState.take}
                total={dataSource.total}
                // filterable={true}
                pageable={{
                  buttonCount: 5,                 
                  pageSizes: true,
                }}            
                dataItemKey={DATA_ITEM_KEY}
                selectedField={SELECTED_FILED}   
                selectable = {{
                  enable: true,
                  drag: false, 
                  cell: false, 
                  mode: "multiple",
                }}
                onPageChange={handlePageChange}     
                // onFilterChange={handleFilterChange} 
                onSelectionChange={onSelectionChange}          
                onHeaderSelectionChange={onHeaderSelectionChange}              
                >              
                <GridColumn field={SELECTED_FILED} width="50px" filterable={false}     
                  headerSelectionValue= {
                    dataSource.results.findIndex((item) => !selectedState[idGetter(item)]) === -1
                  }         
                />                      
                {/* <GridColumn filterable={false} cell={testCell}/>        */}
                <GridColumn field="userTerm"  title="대상자명" width="140px"/>
                <GridColumn field="rgnTerm"  title="시군구" width="180px" />
                <GridColumn field="dongTermSimple"  title="읍면동" width="180px" />
                {/* <GridColumn field="userTerm"  title="대상자명" width="140px" filterCell={GridColumnInputFilter} /> */}
                {/* <GridColumn field="rgnTerm"  title="시군구" width="160px" filterCell={rgnFilterDropDown}/>
                <GridColumn field="dongTermSimple"  title="읍면동" width="140px" filterCell={dongFilterDropDown}/> */}
                <GridColumn field="cid"  title="CID" width="200px" filterCell={GridColumnInputFilter}/>              
                <GridColumn field="imei"  title="IMEI" width="240px" filterable={false}/>
                <GridColumn field="firmwareVersion"  title="펌웨어 버전" width="200px" filterable={false}/>              
                <GridColumn field="deviceLidarDistance"  title="센서감도" width="140px" filterable={false}/>
                <GridColumn field="deviceCycle"  title="수집주기(s)" width="140px" filterable={false}/>              
                {/* <GridColumn field="gathDtm"  title="수집시간" filterable={false}/>    
                <GridColumn field="movement"  title="움직임" width="80px" filterable={false}/>
                <GridColumn field="velocity"  title="속도" width="80px" filterable={false}/>
                <GridColumn field="temperature"  title="온도" width="80px" filterable={false}/>
                <GridColumn field="humidity"  title="습도" width="80px" filterable={false}/>
                <GridColumn field="light"  title="조도" width="80px" filterable={false}/>
                <GridColumn field="co2"  title="CO2" width="80px" filterable={false}/>
                <GridColumn field="tvoc"  title="TVOC" width="80px" filterable={false}/> */}
                <GridColumn field="cmdType"  title="제어 명령" filterable={false}/>     
                <GridColumn field="cmdStatus"  title="상태" width="100px" filterable={false}/>     
                <GridColumn 
                  field="record"  
                  title="이력관리" 
                  width="80px" 
                  filterable={false}
                  cell={props => (
                    <td>
                      <a onClick= {e => {
                        e.preventDefault();
                        devInfoEvtBtn(props.dataItem);
                      }}>
                        <i>
                          <Search />
                        </i>
                      </a>
                    </td>
                  )}
                />    
                { userInfo.userTypeCode === 2005 ?
                <GridColumn field="dangerEvent"  title="위험전환" width="80px" filterable={false}
                  cell={props => (
                    <td>
                      <a onClick= {e => {
                        e.preventDefault();
                        dangerEvent(props.dataItem);
                      }}>
                        <i>
                          <Check />
                        </i>
                      </a>
                    </td>
                  )}
                />
                :
                null
                }     
                <GridNoRecords>데이터가 존재하지 않습니다.</GridNoRecords>
              </Grid>
            </IntlProvider>
          </LocalizationProvider>
          {deviceInfo.visible && (
            <DeviceInfo 
              conn={conn}
              deviceInfo={deviceInfo}
              setDeviceInfo={setDeviceInfo}
              cmdList={cmdList}
            />
          )}
        {/* <LocalizationProvider language="ko-KR">
          <IntlProvider locale="ko">
            <Grid
              className={styles.grid}
              // data={gridDs}
              // total={total}
            >

            </Grid>
          </IntlProvider>
        </LocalizationProvider> */}
      </div>
    </>
   
  );
}

export default DeviceCmd;